var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinInner = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 10.905A3.989 3.989 0 0 1 6.75 8c0-1.144.48-2.176 1.25-2.905.77.73 1.25 1.761 1.25 2.905S8.77 10.176 8 10.905z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 11.873a4.75 4.75 0 1 0 0-7.747 4.75 4.75 0 1 0 0 7.747zm-.596-.502a4 4 0 1 1 0-6.742c.184-.183.384-.351.596-.502.212.15.412.319.596.502a4 4 0 1 1 0 6.742 4.772 4.772 0 0 1-.596.502 4.772 4.772 0 0 1-.596-.502z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinInner);
export default ForwardRef;